import { Row, type RowProps } from '@christiankaindl/lyts'
import { type ReactNode, type CSSProperties } from 'react'
import { type LucideIcon } from 'lucide-react'
import * as styles from './Pill.css'

export type PillTone = keyof typeof styles.tone

interface Props extends RowProps {
  gap?: number
  children?: ReactNode
  style?: CSSProperties
  /** `tight` for pills whose content already has round ends. */
  padding?: 'default' | 'tight'
  /** Colour role. Task statuses use their `TaskStatus` name. */
  tone?: PillTone
  size?: keyof typeof styles.size
  icon?: LucideIcon
}
export default function Pill({
  children,
  gap = 0.5,
  padding = 'default',
  tone = 'neutral',
  size = 'default',
  icon: Icon,
  ...props
}: Props) {
  return (
    <Row
      asChild
      gap={size === 'sm' ? 0.375 : gap}
      {...props}
      className={`${styles.root} ${styles.padding[padding === 'default' && size === 'sm' ? 'defaultSm' : padding]} ${styles.size[size]} ${styles.tone[tone]}${props.className ? ` ${props.className}` : ''}`}
    >
      <span>
        {Icon && (
          <Icon
            size={size === 'sm' ? 12 : 13}
            className={styles.icon}
            aria-hidden
          />
        )}
        {children}
      </span>
    </Row>
  )
}
